import { O_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { O_BUSINESS_DETAIL } from "@/src-refactor/modules/shared/model/const/property/bussines-detail";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareBusinessTypeToClient = (res: IPropertyDetailsResponse) => {
    const business = O_BUSINESS_TYPE[res?.businesstype_id];
    return {
      business_type: [O_BUSINESS_TYPE[business.combine.business]],
      detail_business_type: [O_BUSINESS_DETAIL[business.combine.detail]]
    };
  };

  export default prepareBusinessTypeToClient